import { Apis } from "../../lib/Apis";

export const useInteriorDesignCategory = () => {
    const addInteriorDesignCategory = async (categoryData) => {
        try {
            const response = await Apis.addInteriorDesignCategory(categoryData);
            return response;
        } catch (error) {
            throw error;
        }
    };
    const getInteriorDesignCategories = async () => {
        try {
            const response = await Apis.getInteriorDesignCategories();
            return response.data;
        } catch (error) {
            throw error;
        }
    };

    const getInteriorDesignCategoriesWithPagination = async (offset = 0, limit = 10, name = "", status = "") => {
        try {
            const params = {};
            if (name) {
                params.name = name;
            }
            if (status !== "") {
                params.status = status === "true" ? true : status === "false" ? false : status;
            }
            const response = await Apis.getInteriorDesignCategoriesWithPagination(offset, limit, params);
            return response.data;
        } catch (error) {
            throw error;
        }
    };
    const updateInteriorDesignCategory = async (id, categoryData) => {
        try {
            const response = await Apis.updateInteriorDesignCategory(id, categoryData);
            return response;
        } catch (error) {
            throw error;
        }
    };
    const deleteInteriorDesignCategory = async (categoryId) => {
        try {
            const response = await Apis.deleteInteriorDesignCategory(categoryId);
            return response;
        } catch (error) {
            throw error;
        }
    };
    const toggleInteriorDesignCategoryStatus = async (categoryId, status) => {
        try {
            const response = await Apis.toggleInteriorDesignCategoryStatus(categoryId, status);
            return response;
        } catch (error) {
            throw error;
        }
    };

    const getAllInteriorDesignCategories = async () => {
        try {
            const response = await Apis.getAllInteriorDesignCategories();
            return response.data.data;
        } catch (error) {
            throw error;
        }
    };

    const updateInteriorDesignCategoryPosition = async (categoryId, newPosition) => {
        try {
            const response = await Apis.updateInteriorDesignCategoryPosition({ categoryId, newPosition });
            return response;
        } catch (error) {
            throw error;
        }
    };

    return {
        addInteriorDesignCategory,
        getInteriorDesignCategories,
        getInteriorDesignCategoriesWithPagination,
        updateInteriorDesignCategory,
        deleteInteriorDesignCategory,
        toggleInteriorDesignCategoryStatus,
        getAllInteriorDesignCategories,
        updateInteriorDesignCategoryPosition
    }
}